import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Slim, muted compliance footer mounted on every authenticated page
 * (Ladder / Challenges / Admin / etc). Public auth screens get their
 * own bigger footer; legal pages have their own header chrome.
 *
 * Per the user's design directive: minimal typography, muted color,
 * non-intrusive spacing — no clutter on the product UI.
 */
export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="px-6 pt-6 pb-4 flex flex-wrap items-center justify-center gap-2 text-[10px] text-[#9aa39d]"
    >
      <Link to="/privacy" className="hover:text-[#015e3f] transition-colors" data-testid="footer-privacy-link">
        Privacy
      </Link>
      <span aria-hidden="true" className="text-[#e3dcd1]">·</span>
      <Link to="/terms" className="hover:text-[#015e3f] transition-colors" data-testid="footer-terms-link">
        Terms
      </Link>
      <span aria-hidden="true" className="text-[#e3dcd1]">·</span>
      <Link to="/sms-terms" className="hover:text-[#015e3f] transition-colors" data-testid="footer-sms-terms-link">
        SMS Terms
      </Link>
    </footer>
  );
}
